import YYTabs from './tabs.vue'
import YYTabPane from './pane.vue'

YYTabs.YYTabPane = YYTabPane
export default YYTabs